import React from 'react'
import Button from '../../../components/buttons/buttons.component'
import styled, { keyframes } from 'styled-components'
import AccordionSecondary from './../../../components/accordion/accordion-secondary.component'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import PaymentDataConfirmation from './payment-data-confirmation.component'
import PromotionDataConfirmation from './promotion-data-confirmation.component'
import OrderSummaryConfirmation from './order-summary-confirmation.component'
import CreditCardPurchaseSelectors from '../../../ducks/credit-card-purchase/credit-card-purchase.selectors'
import { connect } from 'react-redux'
import { history } from './../../../helpers/history'
import PromotionCouponService from '../../../services/promotion-coupon.service'
import { PAYMENT_METHODS } from '../../../constants'
import { toastActions } from '../../../actions'
import { downloadFromURL } from '../../../helpers/download.helper'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import { Creators as ClientTicketModalCreators } from '../../../ducks/client-ticket-modal/client-ticket-modal'
import FontAwesome from 'react-fontawesome'
import { ClientTicketService } from '../../../services/client-ticket.service'
import ClientTicketModalContainer from '../../private/client/my-purchases/components/client-ticket-modal-container.component'
import ModalConfirmation from '../../../components/modal/modal-confirmation.component'
import FileSaver from 'file-saver'
import PixInfo from '../../../components/pix/pix-info.component'
import { EmissionPollingGate } from './emission-polling-gate'
import { EmissionProgress } from './post-payment-outcome'
import {
	POST_PAYMENT_MESSAGES,
	POST_PAYMENT_TIMINGS,
} from '../../../constants/post-payment.constants'
import { routes } from '../../../constants/routes.constants'

const EMISSION_POLL_INTERVAL_MS = POST_PAYMENT_TIMINGS.EMISSION_POLL_INTERVAL_MS

// Frases que se alternam com efeito de "digitando e apagando" enquanto o
// pedido de bilhetes de onibus e processado em segundo plano.
const EMISSION_TYPEWRITER_PHRASES = [
	'Verificando o pagamento',
	'Confirmando a reserva das poltronas',
	'Emitindo o(s) bilhete(s)',
	'Gerando o código de embarque',
	'Processando a emissão',
]
const EMISSION_TYPEWRITER_TYPE_SPEED_MS = 70
const EMISSION_TYPEWRITER_DELETE_SPEED_MS = 35
const EMISSION_TYPEWRITER_PAUSE_TYPED_MS = 1400
const EMISSION_TYPEWRITER_PAUSE_DELETED_MS = 300

class ConfirmationStepComponent extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			message: '',
			isPromotionLoaded: false,
			emissionText: '',
			emissionTypewriterDone: false,
			emissionFailed: false,
			// Spec 056 (T125, D39): Pix ja pago ha 240s e a emissao sem desfecho.
			// Nao e falha - o polling continua; o cliente so e tranquilizado.
			emissionSlow: false,
		}

		this.emissionPollingGate = new EmissionPollingGate()
		this.emissionPollTimer = null
		this.emissionTypewriterTimer = null
		this.emissionTypewriterPhraseIndex = 0
		this.emissionTypewriterCharIndex = 0
		this.emissionTypewriterPhase = 'typing'

		this.getAccordionItems = getAccordionItems.bind(this)
		this.getPromotionCouponMessage = getPromotionCouponMessage.bind(this)
		this.promotionCouponControl = promotionCouponControl.bind(this)
		this.emissionPollingControl = emissionPollingControl.bind(this)
		this.startEmissionPolling = startEmissionPolling.bind(this)
		this.tickEmissionTypewriter = tickEmissionTypewriter.bind(this)
		this.stopEmissionPolling = stopEmissionPolling.bind(this)
		this.finishEmissionTypewriter = finishEmissionTypewriter.bind(this)
		this.checkEmissionStatus = checkEmissionStatus.bind(this)
		this.closeEmissionErrorModal = closeEmissionErrorModal.bind(this)
		this.closeEmissionSlowModal = closeEmissionSlowModal.bind(this)
		this.goToMyPurchases = goToMyPurchases.bind(this)
	}
	componentDidMount() {
		if (!this.props.isConfirmationStep) {
			this.setState({ isPromotionLoaded: false, message: '' })
		}
	}

	componentWillUnmount() {
		this.stopEmissionPolling()
	}

	downloadBpe = async () => {
		const {
			ticketsGoing,
			ticketsReturn,
			orderNumber,
			buyerId,
			user,
			showLoading,
			hideLoading,
			toastDanger,
		} = this.props
		const error = () => {
			toastDanger({
				message: 'Não foi possível fazer o download dos arquivos.',
			})
			hideLoading()
		}
		showLoading()
		ticketsGoing.map((f) => {
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Checkin de Embarque'
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Checkin de Embarque ${f.passengerName.toUpperCase()}.png`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Passagem DaBPE'
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
		})
		ticketsReturn.map((f) => {
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Checkin de Embarque'
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Checkin de Embarque ${f.passengerName.toUpperCase()}.png`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
			ClientTicketService.download(
				orderNumber,
				f.trackNumber,
				buyerId || user.id,
				'Passagem DaBPE',
				`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
			)
				.then((response) => {
					const { data } = response
					if (data)
						FileSaver.saveAs(
							data,
							`Passagem DaBPE ${f.passengerName.toUpperCase()}.pdf`
						)
				})
				.catch(() => error())
				.finally(() => hideLoading())
		})
	}

	render() {
		const emv = this.props.pixData ? this.props.pixData.emv : ''
		const qrCodeBase64 = this.props.pixData
			? this.props.pixData.qrCodeBase64
			: ''
		const pixLink = this.props.pixData ? this.props.pixData.pixLink : ''
		const pixExpiration =
			this.props.pixData && this.props.pixData.pixExpiration
				? new Date(this.props.pixData.pixExpiration)
				: new Date()

		const notAuthenticated = this.props.user === null
		const bankSlipLink = this.props.bankSlipLink
		const orderNumber = this.props.orderNumber.toString()
		const showBpeDownloadLink = this.props.showBpeDownloadLink
		const isPendingEmission = this.props.isPendingEmission
		const renderBankSlipInfo =
			!isPendingEmission &&
			this.props.paymentMethod === PAYMENT_METHODS.BANKSLIP
		// Ao contrário do boleto/bpe, o Pix precisa continuar visível mesmo
		// com a emissão pendente: o QR Code é como o cliente paga, e o
		// polling de emissão roda por trás dele até o pagamento ser
		// identificado e o(s) bilhete(s) serem emitidos.
		const renderPixInfo = this.props.paymentMethod === PAYMENT_METHODS.PIX
		const renderBpeInfo =
			!isPendingEmission &&
			(this.props.paymentMethod === PAYMENT_METHODS.CREDIT_CARD ||
				this.props.paymentMethod === PAYMENT_METHODS.ONLINE_DEBT ||
				this.props.paymentMethod === PAYMENT_METHODS.MUVICARD)

		this.promotionCouponControl()
		this.emissionPollingControl()
		return (
			this.props.isConfirmationStep && (
				<React.Fragment>
					{!isPendingEmission && (
						<AccordionSecondary
							multiple
							noAnimated
							noClickable
							arrow={false}
							items={this.getAccordionItems()}
						/>
					)}
					<StyledDiv>
						<p style={{ marginBottom: '0' }}>
							<span className="f-x-large orange">
								Um e-mail de confirmação foi enviado para{' '}
								{this.props.buyerEmail || this.props.user.email}!
							</span>
						</p>

						{isPendingEmission && (
							<span className="f-x-large">
								<p className="f-x-large">
									{this.props.paymentMethod === PAYMENT_METHODS.PIX
										? 'Assim que identificarmos o pagamento via Pix, a emissão do(s) bilhete(s) será iniciada automaticamente.'
										: 'Seu pagamento foi aprovado! A emissão do(s) bilhete(s) pode levar alguns minutos.'}
								</p>
								<p className="f-x-large">
									Você receberá o(s) bilhete(s) por e-mail assim que a
									emissão for concluída, ou pode consultá-lo(s) a
									qualquer momento na opção{' '}
									<b>Minhas Compras</b>.
								</p>
								<p className="f-x-large">
									Se preferir, você pode aguardar aqui nesta tela: assim
									que a emissão for concluída, mostraremos automaticamente
									o(s) bilhete(s) para você.
								</p>
								{!this.state.emissionTypewriterDone && (
									<p className="f-x-large orange">
										<StyledTypewriter>
											{this.state.emissionText}
											<span className="cursor">|</span>
										</StyledTypewriter>
									</p>
								)}
							</span>
						)}

						{renderBankSlipInfo && (
							<span className="f-x-large">
								<p className="f-x-large">
									O pagamento do boleto pode levar até 3 dias úteis
									para constar em nosso sistema.
								</p>
								<p className="f-x-large">
									O Não Pagamento ou Pagamentos realizados após o
									vencimento implica no cancelamento automático das
									reservas.
								</p>
								<p className="f-x-large">
									<div
										style={{
											display: 'flex',
											justifyContent: 'center',
											margin: '4rem auto',
										}}>
										<Button
											primary
											onClick={() => {
												const { showLoading, hideLoading } =
													this.props
												showLoading()

												const downloadPromise = downloadFromURL(
													bankSlipLink,
													`boleto-moveflex-pedido-${orderNumber}.pdf`
												)

												downloadPromise
													.then(() => hideLoading())
													.catch(() => hideLoading())
											}}>
											Imprimir boleto
										</Button>
									</div>
								</p>
							</span>
						)}

						{renderPixInfo && (
							<span className="f-x-large">
								<p className="f-x-large">
									O não pagamento implica no cancelamento automático da
									reserva de passagem.
								</p>
								<PixInfo
									pixImageQrCode={qrCodeBase64}
									pixValidity={pixExpiration}
									pixEmv={emv}
								/>
							</span>
						)}

						{renderBpeInfo &&
							(showBpeDownloadLink ? (
								<span className="f-x-large">
									<br />
									<p className="f-x-large">
										O seu bilhete de passagem foi enviado via e-mail
										ou você pode salvar clicando no botão azul abaixo
										nesta página!
									</p>
									<p className="f-x-large">
										É obrigatório a apresentação do mesmo para
										embarque. A rodoviária não realiza impressão de
										segunda via de bilhete de passagem.
									</p>
									<p>
										<Button
											secondary
											type="button"
											onClick={this.downloadBpe}>
											<span style={{ marginRight: 5 }}>
												<FontAwesome name="qrcode" size="lg" />
											</span>
											<span style={{ marginRight: 5 }}>
												<FontAwesome name="download" size="lg" />
											</span>
											Salvar Passagem(ns) Digital(is)
										</Button>
									</p>
								</span>
							) : (
								<span className="f-x-large">
									<br />
									<p className="f-x-large">
										<b>Para viagens DENTRO DO RS</b>, você receberá
										sua passagem digital e cartão de embarque para
										apresentá-los de forma digital ou impressa
										diretamente no embarque!
									</p>
									<p className="f-x-large">
										<b>Para viagens ENTRE ESTADOS</b>, este documento
										deverá ser apresentado na estação rodoviária de
										embarque ou no guichê da empresa para emissão de
										seu(s) bilhete(s) eletrônico(s).
									</p>
									<p className="f-x-large">
										Também é possível visualizar seu voucher no painel
										do cliente, no menu “Minhas compras”
									</p>
								</span>
							))}

						{notAuthenticated ||
						renderBankSlipInfo ||
						renderPixInfo ? null : (
							<div className="button-container">
								<Button
									primary
									type="button"
									onClick={() =>
										history.push('/cliente/minhas-compras')
									}>
									Minhas Compras
								</Button>
							</div>
						)}
					</StyledDiv>
					{isPendingEmission && (
						<React.Fragment>
							<ClientTicketModalContainer handleCancelTicket={() => {}} />
							{/* Spec 056 (US6): este modal afirmava "seu bilhete nao foi
							    gerado" e "a compra nao sera cobrada" depois de UMA consulta
							    falha. No bug 8005 as duas frases eram falsas - o BP-e estava
							    sendo emitido e o cartao ja tinha sido cobrado -, e a terceira
							    ("efetue uma nova tentativa") produzia a compra duplicada.
							    Agora so aparece apos N falhas SEGUIDAS, e diz o que de fato
							    se sabe. */}
							<ModalConfirmation
								isOpen={this.state.emissionFailed}
								onResult={this.goToMyPurchases}
								OnlyNoButton
								buttonNoText={POST_PAYMENT_MESSAGES.GO_TO_MY_PURCHASES}
								title={POST_PAYMENT_MESSAGES.EMISSION_GAVE_UP_TITLE}>
								<p>{POST_PAYMENT_MESSAGES.EMISSION_GAVE_UP_BODY}</p>
							</ModalConfirmation>
							{/* Spec 056 (T125, D39): convite, nao erro - so com o Pix ja
							    pago (paymentReceived do Hub). O polling continua. */}
							<ModalConfirmation
								isOpen={this.state.emissionSlow && !this.state.emissionFailed}
								onResult={this.closeEmissionSlowModal}
								buttonYesText={POST_PAYMENT_MESSAGES.GO_TO_MY_PURCHASES}
								buttonNoText={POST_PAYMENT_MESSAGES.KEEP_WAITING}
								title={
									<StyledSlowTitle>
										{POST_PAYMENT_MESSAGES.EMISSION_SLOW_TITLE}
									</StyledSlowTitle>
								}>
								<p>{POST_PAYMENT_MESSAGES.EMISSION_SLOW_BODY}</p>
							</ModalConfirmation>
						</React.Fragment>
					)}
				</React.Fragment>
			)
		)
	}
}

// O titulo padrao do ModalConfirmation e grande demais para esta frase. Reduzido
// SO aqui: o modal e compartilhado por varias telas.
const StyledSlowTitle = styled.span`
	display: block;
	font-size: 2.2rem;
	font-weight: 600;
	line-height: 1.25;
`

const StyledDiv = styled.div`
	margin-bottom: 6rem;
	margin-top: 3rem;
	text-align: center;

	.button-container {
		margin-top: 1.5rem;
	}
`

const blink = keyframes`
	0%, 49% {
		opacity: 1;
	}
	50%, 100% {
		opacity: 0;
	}
`

const StyledTypewriter = styled.span`
	.cursor {
		animation: ${blink} 1s step-start infinite;
	}
`

function getAccordionItems() {
	const { installmentsQtt } = this.props
	const orderNumber = this.props.orderNumber.toString()
	const orderNumberLength = 6
	const formattedOrderNumber =
		orderNumber.length > orderNumberLength
			? orderNumber
			: ('0'.repeat(orderNumberLength) + orderNumber).slice(
					-orderNumberLength
			  )

	var accordionArray = [
		{
			title: `Resumo do pedido ${formattedOrderNumber}`,
			initiallyOpened: true,
			content: <OrderSummaryConfirmation />,
		},
	]

	if (installmentsQtt > 0)
		accordionArray.push({
			title: 'Dados do pagamento',
			initiallyOpened: true,
			content: <PaymentDataConfirmation />,
		})

	accordionArray.push({
		title: this.state.message != '' ? 'Promoção' : '',
		initiallyOpened: true,
		content: <PromotionDataConfirmation message={this.state.message} />,
	})
	return accordionArray
}

function getPromotionCouponMessage() {
	const orderNumber = this.props.orderNumber
	const paymentMethod = this.props.paymentMethod

	if (orderNumber > 0 && paymentMethod !== PAYMENT_METHODS.BANKSLIP) {
		PromotionCouponService.getUberCouponByOrderNumber(orderNumber).then(
			({ data }) => {
				data
					? this.setState({ message: data.notes, isPromotionLoaded: true })
					: this.setState({ message: '', isPromotionLoaded: true })
			}
		)
	} else {
		this.setState({ message: '', isPromotionLoaded: true })
	}
}

function promotionCouponControl() {
	if (!this.props.isConfirmationStep) {
		if (this.state.message != '') {
			this.setState({ message: '', isPromotionLoaded: false })
		}
		if (this.state.isPromotionLoaded) {
			this.setState({ isPromotionLoaded: false })
		}
	}

	if (this.props.isConfirmationStep && !this.state.isPromotionLoaded) {
		this.getPromotionCouponMessage()
	}
}

// A emissao dos bilhetes (cartao/Muvicard no checkout novo) e assincrona -
// consulta o pedido na MuviHub a cada 5s ate ele sair de "Em processamento",
// entao abre o mesmo modal de detalhes usado em "Minhas Compras".
function emissionPollingControl() {
	const { isConfirmationStep, isPendingEmission, orderId, user } = this.props

	// Compra sem login (guest) nao tem token para consultar "me/orders" na
	// MuviHub - a propria tela ja esconde o acesso a "Minhas Compras" nesse caso.
	if (!isConfirmationStep || !isPendingEmission || !orderId || !user) return

	if (this.emissionPollingGate.shouldStart(orderId)) {
		this.startEmissionPolling()
	}
}

function startEmissionPolling() {
	this.tickEmissionTypewriter()

	// Spec 056 (US6): a partir daqui conta a tolerancia a erros seguidos. Antes, a
	// PRIMEIRA consulta que falhasse ja abria um modal afirmando que a compra nao
	// seria cobrada.
	this.emissionProgress = new EmissionProgress()

	this.checkEmissionStatus()
	this.emissionPollTimer = setInterval(
		this.checkEmissionStatus,
		EMISSION_POLL_INTERVAL_MS
	)
}

// Efeito de maquina de escrever: digita uma frase, pausa, apaga, pausa e
// passa pra proxima - em loop entre EMISSION_TYPEWRITER_PHRASES.
function tickEmissionTypewriter() {
	let delay = EMISSION_TYPEWRITER_TYPE_SPEED_MS

	switch (this.emissionTypewriterPhase) {
		case 'typing': {
			const phrase =
				EMISSION_TYPEWRITER_PHRASES[this.emissionTypewriterPhraseIndex]
			this.emissionTypewriterCharIndex += 1

			if (this.emissionTypewriterCharIndex >= phrase.length) {
				this.emissionTypewriterPhase = 'paused-typed'
				delay = EMISSION_TYPEWRITER_PAUSE_TYPED_MS
			}
			break
		}
		case 'paused-typed':
			this.emissionTypewriterPhase = 'deleting'
			delay = EMISSION_TYPEWRITER_DELETE_SPEED_MS
			break
		case 'deleting':
			this.emissionTypewriterCharIndex -= 1

			if (this.emissionTypewriterCharIndex <= 0) {
				this.emissionTypewriterPhase = 'paused-deleted'
				delay = EMISSION_TYPEWRITER_PAUSE_DELETED_MS
			}
			break
		case 'paused-deleted':
		default:
			this.emissionTypewriterPhraseIndex =
				(this.emissionTypewriterPhraseIndex + 1) %
				EMISSION_TYPEWRITER_PHRASES.length
			this.emissionTypewriterCharIndex = 0
			this.emissionTypewriterPhase = 'typing'
			break
	}

	const currentPhrase =
		EMISSION_TYPEWRITER_PHRASES[this.emissionTypewriterPhraseIndex]

	this.setState({
		emissionText: currentPhrase.slice(0, this.emissionTypewriterCharIndex),
	})

	this.emissionTypewriterTimer = setTimeout(this.tickEmissionTypewriter, delay)
}

function stopEmissionPolling() {
	clearInterval(this.emissionPollTimer)
	clearTimeout(this.emissionTypewriterTimer)
	this.emissionPollTimer = null
	this.emissionTypewriterTimer = null
}

// Chamado quando a consulta de status termina (sucesso ou erro): para o
// polling e deixa a palavra que estava sendo digitada terminar de ser
// apagada, em vez de sumir congelada pela metade.
function finishEmissionTypewriter() {
	clearInterval(this.emissionPollTimer)
	this.emissionPollTimer = null
	clearTimeout(this.emissionTypewriterTimer)

	const eraseStep = () => {
		if (this.emissionTypewriterCharIndex <= 0) {
			this.emissionTypewriterTimer = null
			this.setState({ emissionText: '', emissionTypewriterDone: true })
			return
		}

		this.emissionTypewriterCharIndex -= 1
		const currentPhrase =
			EMISSION_TYPEWRITER_PHRASES[this.emissionTypewriterPhraseIndex]

		this.setState({
			emissionText: currentPhrase.slice(0, this.emissionTypewriterCharIndex),
		})

		this.emissionTypewriterTimer = setTimeout(
			eraseStep,
			EMISSION_TYPEWRITER_DELETE_SPEED_MS
		)
	}

	eraseStep()
}

function checkEmissionStatus() {
	const {
		orderId,
		orderNumber,
		fetchOrderForModal,
		openClientTicketModal,
	} = this.props

	ClientTicketService.getOrder(orderId, { orderNumber })
		.then((order) => {
			this.emissionProgress.registerSuccess()

			// Spec 056 (US5/US6): "Em análise" tambem encerra a espera - o desfecho
			// automatico acabou e o que falta e acao humana. Sem isso o cliente
			// ficava numa tela de carregamento que nunca terminaria.
			if (!EmissionProgress.isFinalSituation(order.status)) {
				// Spec 056 (T125, D39): Pix ja pago ha 240s sem desfecho - tranquiliza
				// e convida a acompanhar, SEM parar o polling. Pix nao pago (ou campo
				// ausente) e cartao/Muvicard seguem sem convite.
				const now = Date.now()
				this.emissionProgress.registerOrder(
					order,
					now,
					this.props.paymentMethod === PAYMENT_METHODS.PIX
				)
				if (this.emissionProgress.shouldInvite(now))
					this.setState({ emissionSlow: true })
				return
			}

			// A emissao chegou a um desfecho: os avisos de "em andamento" e de
			// desistencia perdem o sentido e precisam SAIR antes de o bilhete
			// aparecer, senao ficam empilhados por cima das informacoes da viagem.
			this.setState({ emissionSlow: false, emissionFailed: false })

			this.finishEmissionTypewriter()
			fetchOrderForModal(orderId, orderNumber).then(openClientTicketModal)
		})
		.catch(() => {
			// Spec 056 (US6): um soluco de rede nao derruba uma emissao saudavel.
			// So depois de N falhas SEGUIDAS a tela desiste de consultar - e, ao
			// desistir, convida a acompanhar em vez de afirmar o que nao sabe.
			if (!this.emissionProgress.registerError()) return

			this.finishEmissionTypewriter()
			this.setState({ emissionFailed: true })
		})
}

function closeEmissionErrorModal() {
	this.setState({ emissionFailed: false })
}

// Spec 056 (T125): "Ir para Minhas Compras" leva para la; "Continuar aguardando"
// so fecha o aviso - o polling nunca parou.
function closeEmissionSlowModal(goToPurchases) {
	this.setState({ emissionSlow: false })
	if (goToPurchases) {
		this.stopEmissionPolling()
		history.push(routes.CLIENTE + routes.ICONMYSHOPPING)
	}
}

function goToMyPurchases() {
	this.setState({ emissionFailed: false })
	history.push(routes.CLIENTE + routes.ICONMYSHOPPING)
}

const mapStateToProps = (store) => ({
	user: store.user,
	buyerId: store.ticketSale.buyerId,
	buyerEmail: store.ticketSale.buyerEmail,
	orderNumber: store.ticketSale.orderNumber,
	paymentMethod: store.ticketSale.paymentMethod,
	showBpeDownloadLink: store.ticketSale.showBpeDownloadLink,
	isPendingEmission: store.ticketSale.isPendingEmission,
	orderId: store.ticketSale.orderId,
	installmentsQtt: CreditCardPurchaseSelectors.getInstallmentsQtt(
		store.creditCardPurchase
	),
	isConfirmationStep: TicketSaleSelectors.isConfirmationStep(store),
	lastFourNumbers: CreditCardPurchaseSelectors.getCardLastFourNumbers(
		store.creditCardPurchase
	),
	bankSlipLink: store.ticketSale.bankSlipLink,
	pixData: store.ticketSale.pixData,
	ticketsGoing: store.ticketSale.confirmedTicketsGoing,
	ticketsReturn: store.ticketSale.confirmedTicketsReturn,
	anticipatedPix: store.ticketSale.anticipatedPix,
})

const mapDispatchToProps = {
	showLoading: SiteCreators.showLoading,
	hideLoading: SiteCreators.hideLoading,
	toastDanger: toastActions.danger,
	fetchOrderForModal: ClientTicketModalCreators.fetchData,
	openClientTicketModal: ClientTicketModalCreators.openModal,
}

const ConfirmationStep = connect(
	mapStateToProps,
	mapDispatchToProps
)(ConfirmationStepComponent)

export default ConfirmationStep
